import React from "react";
import MaskedInput from "react-text-mask";
import NumberFormat from "react-number-format";
import { omit } from "lodash";

export const TextMaskPhone: React.FC = (props) => {
  const other = omit(props, ["inputRef"]);

  return (
    <MaskedInput
      {...other}
      mask={["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={"\u2000"}
      showMask
    />
  );
};

type TextMaskCurrencyProps = {
  inputRef: (instance: any | null) => void;
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

export const TextMaskCurrency: React.FC<TextMaskCurrencyProps> = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values: any) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix="$"
    />
  );
};
